import React from 'react';
import {ReactComponent as Logo} from 'images/cs-logo.svg';
import makeStyles from '@mui/styles/makeStyles';
import LoginForm from 'features/login/LoginForm';
import {get} from 'lodash';
import {Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles((theme) => ({
   header: {
      padding: theme.spacing(3),
      borderBottom: '5px solid #bed600',
      '& > svg': {
         width: 200,
      },
      marginBottom: theme.spacing(5),
   },
   ieBanner: {
      background: theme.palette.error.dark,
      color: theme.palette.error.contrastText,
      textAlign: 'center',
   },
}));

const LoginPage = () => {
   const classes = useStyles();
   const {t} = useTranslation();

   var isIE = get(window, 'document.documentMode') ? true : false;

   return (
      <>
         <div className={classes.header}>
            <Logo />
         </div>
         {isIE ? (
            <div className={classes.ieBanner}>
               <Typography variant="h4">
                  {t(
                     'You are on an unsupported browser and Diplomat MFT Web Admin might not work.'
                  )}
               </Typography>
               <Typography variant="h5">
                  {t(
                     'Diplomat MFT Web Admin works with the Chrome, Firefox, Safari, or Edge browsers'
                  )}
               </Typography>
            </div>
         ) : (
            <LoginForm />
         )}
      </>
   );
};

export default LoginPage;
